import { render, staticRenderFns } from "./G_110_SeikyuList.vue?vue&type=template&id=60a16aee&scoped=true&"
import script from "./G_110_SeikyuList.vue?vue&type=script&lang=ts&"
export * from "./G_110_SeikyuList.vue?vue&type=script&lang=ts&"
import style0 from "./G_110_SeikyuList.vue?vue&type=style&index=0&id=60a16aee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a16aee",
  null
  
)

export default component.exports